var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('item-content',{attrs:{"item":_vm.item}}),_c('accept-or-reject-preset-action',{attrs:{"item":_vm.item},on:{"updateNotificationList":function($event){return _vm.$emit('updateNotificationList', _vm.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }